import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';

export const adminTransmissionActsFiltersSchema = z
  .object({
    parentCompany: z.string().catch(''),
    companies: z.array(z.string()).catch([]),
    date: dateRangeSchema,
  })
  .merge(paginationFiltersSchema)
  .merge(sortFiltersSchema);
